import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
import { ForgotPassword } from '../classes/forgotPwdModel';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthenticateService {
  loggedUser = {};
  s3Url: string;
  getBack: EventEmitter<any> = new EventEmitter();
  getHeading: EventEmitter<any> = new EventEmitter();
  currentUser: object;
  userName: string = '';
  myApi: any;

  constructor(private http: HttpClient) {}
  getS3Url(){
    this.s3Url = environment.s3Url
  }

  s3url() {
    if (this.s3Url) {
      return this.s3Url
    } else {
      // this.getS3Url();
    }
  }

  getUserDetails(key) {
    if (this.loggedUser != undefined) {
      this.currentUser = this.loggedUser;
      this.userName = this.loggedUser['sub'];
      return this.loggedUser[key];
    } else {
      // this.getToken();
    }

  }

  getUserSession() {
    return this.currentUser;
  }

  getUserName() {
    return this.userName;
  }

  updateProfile(updateObj) {
    return new Promise((resolve, reject) => {
      this.http.post(this.myApi.updateProfile, updateObj).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  updatenewpassword(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.myApi.changePassword, data).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }

  getUserProfile(userObj) {
    return new Promise((resolve, reject) => {
      this.http.get(this.myApi.getCurrentUser + JSON.stringify(userObj)).subscribe(result => {
        this.currentUser = result;
        resolve(result)
      }, reject);
    })
  }

  checkSession() {
    return new Promise((resolve, reject) => {
      this.http.get(this.myApi.getToken).subscribe((session: any) => {
        if (session) {
          this.userName = session.idToken.payload.sub;
          resolve(true);
        } else {
          resolve(false)
        }
      }, reject)
    })
  }

  hideandshowheader() {
    this.getBack.emit();
  }

  sendHeading(heading) {
    this.getHeading.emit(heading);
  }

  logOut() {
    return new Promise((resolve, reject) => {
      this.http.get(this.myApi.logOut).subscribe(result => {
        console.log("logOut result", result);
        resolve(result)
      }, reject);
    })
  }

  forgotPassword(user: ForgotPassword) {
    console.log("userservice", user)
    return new Promise((resolve, reject) => {
      this.http.post(this.myApi.forgotpassword, user).subscribe(result => {
        console.log("result", result);
        resolve(result)
      }, reject);
    })
  }

  updatePassword(user: ForgotPassword) {
    console.log("userservice", user)
    return new Promise((resolve, reject) => {
      this.http.post(this.myApi.updatePassword, user).subscribe(result => {
        console.log("result", result);
        resolve(result)
      }, reject);
    })
  }
}
// return new Promise((resolve, reject) => {
//   Auth.currentSession()
//     .then((session) => {
//       var idTokenExpire = session.getIdToken().getExpiration();
//       var refreshToken = session.getRefreshToken();
//       var currentTimeSeconds = Math.round(+new Date() / 1000);
//       if (idTokenExpire < currentTimeSeconds) {
//         Auth.currentAuthenticatedUser()
//           .then((res) => {
//             res.refreshSession(refreshToken, (err, data) => {
//               if (err) {
//                 Auth.signOut()
//               } else {
//                 config.headers.Authorization = "Bearer " + data.getIdToken().getJwtToken();
//                 resolve(config);
//               }
//             });
//           });
//       } else {
//         config.headers.Authorization = "Bearer " + session.getIdToken().getJwtToken();
//         resolve(config);
//       }
//     })
//     .catch(() => {
//       // No logged-in user: don't set auth header
//       resolve(config);
//     });
// });`
